import logger from '@greenlight/logger';
import getConfig from 'next/config';
import datadogRumClient from '../../utils/datadog-rum';

import { sendHttpRequest } from '../utilities/sendHttpRequest';

const { publicRuntimeConfig } = getConfig();
const INVEST_URL = `${publicRuntimeConfig.stargatewayHost}/v2/invest`;

interface InvestTermsAndConditionsArgs {
  deviceId: string;
  authToken: string;
}

async function postAcceptTermsAndConditions({
  deviceId,
  authToken
}: InvestTermsAndConditionsArgs) {
  return sendHttpRequest<true>({
    method: 'post',
    url: `${INVEST_URL}/accept-terms-and-conditions`,
    params: {
      deviceId
    },
    headers: { authorization: authToken },
    validateResponse: () => true,
    retries: 2
  }).catch(error => {
    logger.error(new Error('Failed to collect Invest T&C acceptance', error));
    datadogRumClient.addAction('Failed to collect Invest T&C acceptance', {
      error
    });
  });
}

export default {
  postAcceptTermsAndConditions
};
